import * as THREE from 'three';
import { ConvexGeometry } from 'three/examples/jsm/geometries/ConvexGeometry.js';
// import { TrackballControls } from 'three/examples/jsm/controls/TrackballControls.js';
import { OrbitControls } from 'three/examples/jsm/controls/OrbitControls.js';
// import './style.css';
import { Permutohedron, braidArrangement } from './geometry.js';
import './css/tailwind/before.css';
import './css/style.css';
import './css/tailwind/after.css';


function animate() {
    requestAnimationFrame(animate);
    controls.update();
    render();
}


function render() {
	renderer.render( scene, camera );
}


window.addEventListener('resize', () => {
    // camera.aspect = window.innerWidth / window.innerHeight;
    // renderer.setSize(window.innerWidth, window.innerHeight);
    // // renderer.setPixelRatio( window.devicePixelRatio );
    // camera.updateProjectionMatrix();
    const height = container.clientHeight; // Math.min(canvas.clientHeight, window.innerHeight);
    const width = container.clientWidth; //Math.min(canvas.clientWidth, window.innerWidth);
    renderer.setSize(width, height);
    camera.aspect = width / height;
    camera.updateProjectionMatrix();
});


const canvas = document.getElementById('canvas');
const container = document.getElementById('container');

const renderer = new THREE.WebGLRenderer({canvas, antialias: true});
renderer.setClearColor("#882f39");
renderer.setSize(canvas.clientWidth, canvas.clientHeight);
// renderer.setPixelRatio( canvas.clientWidth / canvas.clientHeight );
// renderer.setSize(window.innerWidth, window.innerHeight);
renderer.setPixelRatio( window.devicePixelRatio );

container.appendChild(renderer.domElement);

const camera = new THREE.PerspectiveCamera( 50, window.innerWidth / window.innerHeight, .1, 2000 );
camera.position.set(8, 8, -2)
camera.lookAt(new THREE.Vector3(0, 0, 0));

const controls = new OrbitControls(camera, renderer.domElement);
// const controls = new TrackballControls(camera, renderer.domElement);

const scene = new THREE.Scene();

const ambient_light = new THREE.AmbientLight( 0x777777 );
scene.add( ambient_light );

const light = new THREE.PointLight( 0x999999, 1.5, 100, 2 );
light.position.set( 10, 10, 10 );
scene.add( light );


const dim = 4;
// let scale = .25;
const SCALE_LB = .02;
const SCALE_UB = 12.5;
let scale = SCALE_LB;

// (new Permutohedron([0, 0, 0], dim, scale)).add_to(scene);

// (new Permutohedron([0, 0, 0], dim, scale)).add_to(scene);
// (new Permutohedron([0, 0, 1], dim, scale)).add_to(scene);
// (new Permutohedron([0, 1, 0], dim, scale)).add_to(scene);
// (new Permutohedron([0, 1, 1], dim, scale)).add_to(scene);
// (new Permutohedron([1, 0, 0], dim, scale)).add_to(scene);
// (new Permutohedron([1, 0, 1], dim, scale)).add_to(scene);
// (new Permutohedron([1, 1, 0], dim, scale)).add_to(scene);
// (new Permutohedron([1, 1, 1], dim, scale)).add_to(scene);
//
// (new Permutohedron([ .5, .5, .5], dim, scale)).add_to(scene);
// (new Permutohedron([ .5, .5,-.5], dim, scale)).add_to(scene);
// (new Permutohedron([ .5,-.5, .5], dim, scale)).add_to(scene);
// (new Permutohedron([ .5,-.5,-.5], dim, scale)).add_to(scene);
// (new Permutohedron([-.5, .5, .5], dim, scale)).add_to(scene);
// (new Permutohedron([-.5, .5,-.5], dim, scale)).add_to(scene);
// (new Permutohedron([-.5,-.5, .5], dim, scale)).add_to(scene);
// (new Permutohedron([-.5,-.5,-.5], dim, scale)).add_to(scene);


const LIM = 2;

for (let i=-LIM; i<=LIM + 1; i++) {
    for (let j=-LIM; j<=LIM + 1; j++) {
        for (let k=-LIM; k<=LIM + 1; k++) {
            (new Permutohedron([ i, j, k], dim, scale, 1., 0xcccccc)).add_to(scene);
        }
    }
}

for (let i=-LIM; i<=LIM; i++) {
    for (let j=-LIM; j<=LIM; j++) {
        for (let k=-LIM; k<=LIM; k++) {
            (new Permutohedron([ i + .5, j + .5, k + .5], dim, scale, 1., 0x222222)).add_to(scene);
        }
    }
}

// for (let each of scene.children) {
//     if (each.isGroup) {
//         // each.children[0].geometry.scale.set(12.5, 12.5, 12.5);
//         console.log(each.children[0].geometry.scale(12.5, 12.5, 12.5));
//         // each.scale.set(12.5, 12.5, 12.5);
//     }
// }

document.addEventListener("DOMContentLoaded", function() {
  // code...
    let scaler = document.getElementById("scaler");
    scaler.addEventListener("input", function f(){
        let v = 1. + scaler.value * (SCALE_UB - 1.) / 100;
        for (let each of scene.children) {
            if (each.isGroup) {
                // each.children[0].geometry.scale.set(12.5, 12.5, 12.5);
                // console.log(each.children[0].geometry.scale(1.1, 1.1, 1.1));
                each.children[0].scale.set(v, v, v);
                // console.log(each.children[0].geometry)
                // each.scale.set(12.5, 12.5, 12.5);
            }
        }
    });
});

animate();
